import { ViewerPreferences } from "./ViewerPreferences";

export function ProfilePreferencesPage() {
  return <ViewerPreferences />;
}
